import { render, staticRenderFns } from "./ConLiquidationsData.vue?vue&type=template&id=92001ab2&scoped=true"
import script from "./ConLiquidationsData.vue?vue&type=script&lang=js"
export * from "./ConLiquidationsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92001ab2",
  null
  
)

export default component.exports